import React from "react";
import "../../Styles/yellowcalf.css/Paid.css";

function Paid() {
  return (
    <div className="paid-container" style={{ paddingTop: "25px" }}>
      <div id="loader-div" className="paid-ajax-loader"></div>

      {/* First small panel */}
      <div className="paid-panel-first">
        <div className="paid-panel-first-title mb-3">Paid</div>
      </div>
      <div className="inv-filters d-flex  gap-3">
        <input
          type="text"
          className="inv-input"style={{ maxWidth: "200px" }}
          placeholder="Search Invoice No."
        />
        <select
          className="form-select "style={{ maxWidth: "200px", textAlign:'center',fontSize:'14px'}}>
          <option value="Select Payment Option">Select Payment Option </option>
          <option value="paypal">Paypal</option>
          <option value="bank">Bank</option>
          <option value="wire-transfer">Wire-transfer</option>
          <option value="cheque">Cheque</option>
          <option value="DD">DD</option>
          <option value="others">Others</option>
          <option value="by cash">By cash</option>
          <option value="payfort">Payfort</option>
          <option value="networkonline">Networkonline</option>
        </select>
       
          <button className="fw-clear-btn">Clear</button>
      </div>
      
      {/* Second panel with table */}
      <div className="paid-panel-second">
        <div className="paid-panel-second-heading" id="status-alert"></div>
        <div className="paid-table-container">
          <table className="paid-table">
            <thead>


              <tr>
                <th style={{textAlign:'center'}}>Sr.No</th>
                <th style={{textAlign:'center'}}>Invoice Number</th>
                <th style={{textAlign:'center'}}>Payment Type</th>
                <th style={{textAlign:'center'}}>Payment Mode</th>
                <th style={{textAlign:'center'}}>Payment Status</th>
                <th style={{textAlign:'center'}}>Payment Identification Number</th>
                <th style={{textAlign:'center'}}>Amount</th>
                <th style={{textAlign:'center'}}>Payment Date</th>
                <th style={{textAlign:'center'}}>Invoice Date</th>
                <th style={{textAlign:'center'}}>Action</th>
              </tr>
            </thead>
            <tbody>
              {[...Array(5)].map((_, i) => (
                <tr key={i}>
                  <td style={{textAlign:'center'}}>{i + 1}</td>
                  <td style={{textAlign:'center'}}>877</td>
                  <td style={{textAlign:'center'}}>Service</td>
                  <td style={{textAlign:'center'}}>Paytm</td>
                  <td style={{textAlign:'center'}}>Paid</td>
                  <td style={{textAlign:'center'}}>877_73554</td>
                  <td style={{textAlign:'center'}}>$2700</td>
                  <td style={{textAlign:'center'}}>Wed Apr 20 2022</td>
                  <td style={{textAlign:'center'}}>Mon Jul 27 2020</td>
                  <td style={{ whiteSpace: "nowrap" }}>
                    <a
                      className="paid-btn-green"
                      href="/accountant/payment/paymentReceipt"
                    >
                      <i class="bi bi-eye"></i>
                    </a>
                    <a
                      className="paid-btn-red"
                      href="/accountant/payment/Receipt_invoice"
                    >
                      <i class="bi bi-play-btn"></i>
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="wallet-main-footer">
            <ul className="wallet-main-pagination">
              <li className="wallet-main-active">
                <a href="#">1</a>
              </li>
              <li>
                <a href="#">2</a>
              </li>
              <li>
                <a href="#">3</a>
              </li>
            </ul>

            <div className="wallet-main-summary">
              Showing <b>1-50</b> of <b>177</b> items.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Paid;
